import * as React from 'react';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import { FocusZone } from '@fluentui/react/lib/FocusZone';
import { observer } from 'mobx-react-lite';
import { useAssetRegistry } from '../hooks/useAssetRegistry';
import TimeStreamAssetTool from './TimeStreamAssetTool';
import {
    TimeStreamToolboxOverflow,
    splitDisplayedTools,
    getNumDisplayedTools,
} from 'owa-timestream-toolbox-common';
import useFirstRunExperience from '../hooks/useFirstRunExperience';

export default observer(function TimeStreamAssetTools() {
    const toolsRef = React.useRef<HTMLDivElement>(null);
    const assetRegistry = useAssetRegistry();
    const { ToolboxCallout } = useFirstRunExperience();

    const enabledToolboxAssets = assetRegistry.toolboxAssets
        ? assetRegistry.toolboxAssets.filter(asset => asset.isAssetEnabled?.() ?? true)
        : [];
    const descriptors = splitDisplayedTools(enabledToolboxAssets, getNumDisplayedTools());

    const displayTools = descriptors.displayItems.map(createTool.bind(null, false));
    const overflowTools: JSX.Element[] = descriptors.overflowItems.map(createTool.bind(null, true));

    return (
        <div ref={toolsRef}>
            <FocusZone role="menu">
                {displayTools}
                {!!overflowTools.length && (
                    <TimeStreamToolboxOverflow overflowItems={overflowTools} />
                )}
            </FocusZone>
            {ToolboxCallout && <ToolboxCallout target={toolsRef} />}
        </div>
    );
});

function createTool(isOverflowTool: boolean, assetDescriptor: AssetDescriptor) {
    return (
        <TimeStreamAssetTool
            key={assetDescriptor.type}
            assetDescriptor={assetDescriptor}
            isOverflowTool={isOverflowTool}
        />
    );
}
